// @generated source--
// scripts/generate-bits/file-generators/component-routes.generator.ts

export const patternRoutes = [
  {
    path: 'accept-rate',
    loadChildren: () =>
      import('./accept-rate/accept-rate-stories.routes').then(m => m.routes),
  },
  {
    path: 'ai-button',
    loadChildren: () =>
      import('./ai-button/ai-button-stories.routes').then(m => m.routes),
  },
  {
    path: 'ai-modal',
    loadChildren: () =>
      import('./ai-modal/ai-modal-stories.routes').then(m => m.routes),
  },
  {
    path: 'ai-text-editor',
    loadChildren: () =>
      import('./ai-text-editor/ai-text-editor-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'auto-complete',
    loadChildren: () =>
      import('./auto-complete/auto-complete-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'auto-link',
    loadChildren: () =>
      import('./auto-link/auto-link-stories.routes').then(m => m.routes),
  },
  {
    path: 'best-practises',
    loadChildren: () =>
      import('./best-practises/best-practises-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'bid-pattern-card',
    loadChildren: () =>
      import('./bid-pattern-card/bid-pattern-card-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'bouncing-dots',
    loadChildren: () =>
      import('./bouncing-dots/bouncing-dots-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'challenge-status-tag',
    loadChildren: () =>
      import('./challenge-status-tag/challenge-status-tag-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'chat-button',
    loadChildren: () =>
      import('./chat-button/chat-button-stories.routes').then(m => m.routes),
  },
  {
    path: 'comment-ui',
    loadChildren: () =>
      import('./comment-ui/comment-ui-stories.routes').then(m => m.routes),
  },
  {
    path: 'completed-jobs',
    loadChildren: () =>
      import('./completed-jobs/completed-jobs-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'directory-item',
    loadChildren: () =>
      import('./directory-item/directory-item-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'earnings',
    loadChildren: () =>
      import('./earnings/earnings-stories.routes').then(m => m.routes),
  },
  {
    path: 'experience',
    loadChildren: () =>
      import('./experience/experience-stories.routes').then(m => m.routes),
  },
  {
    path: 'image-caption',
    loadChildren: () =>
      import('./image-caption/image-caption-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'interactive-text',
    loadChildren: () =>
      import('./interactive-text/interactive-text-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'linkshim',
    loadChildren: () =>
      import('./linkshim/linkshim-stories.routes').then(m => m.routes),
  },
  {
    path: 'loading-avatar',
    loadChildren: () =>
      import('./loading-avatar/loading-avatar-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'loading-text',
    loadChildren: () =>
      import('./loading-text/loading-text-stories.routes').then(m => m.routes),
  },
  {
    path: 'loading-thread-item',
    loadChildren: () =>
      import('./loading-thread-item/loading-thread-item-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'newsfeed-system-messages',
    loadChildren: () =>
      import(
        './newsfeed-system-messages/newsfeed-system-messages-stories.routes'
      ).then(m => m.routes),
  },
  {
    path: 'project-contest-card',
    loadChildren: () =>
      import('./project-contest-card/project-contest-card-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'radio-card',
    loadChildren: () =>
      import('./radio-card/radio-card-stories.routes').then(m => m.routes),
  },
  {
    path: 'review-card',
    loadChildren: () =>
      import('./review-card/review-card-stories.routes').then(m => m.routes),
  },
  {
    path: 'review-count',
    loadChildren: () =>
      import('./review-count/review-count-stories.routes').then(m => m.routes),
  },
  {
    path: 'section-article',
    loadChildren: () =>
      import('./section-article/section-article-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'section-case-study-carousel',
    loadChildren: () =>
      import(
        './section-case-study-carousel/section-case-study-carousel-stories.routes'
      ).then(m => m.routes),
  },
  {
    path: 'section-companies',
    loadChildren: () =>
      import('./section-companies/section-companies-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'section-feature',
    loadChildren: () =>
      import('./section-feature/section-feature-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'section-gallery',
    loadChildren: () =>
      import('./section-gallery/section-gallery-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'section-hero',
    loadChildren: () =>
      import('./section-hero/section-hero-stories.routes').then(m => m.routes),
  },
  {
    path: 'service-offering-carousel',
    loadChildren: () =>
      import(
        './service-offering-carousel/service-offering-carousel-stories.routes'
      ).then(m => m.routes),
  },
  {
    path: 'share-modal',
    loadChildren: () =>
      import('./share-modal/share-modal-stories.routes').then(m => m.routes),
  },
  {
    path: 'showcase-card',
    loadChildren: () =>
      import('./showcase-card/showcase-card-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'skills',
    loadChildren: () =>
      import('./skills/skills-stories.routes').then(m => m.routes),
  },
  {
    path: 'upgrade-item',
    loadChildren: () =>
      import('./upgrade-item/upgrade-item-stories.routes').then(m => m.routes),
  },
  {
    path: 'upgrade-tag',
    loadChildren: () =>
      import('./upgrade-tag/upgrade-tag-stories.routes').then(m => m.routes),
  },
  {
    path: 'user-feedback',
    loadChildren: () =>
      import('./user-feedback/user-feedback-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'user-info',
    loadChildren: () =>
      import('./user-info/user-info-stories.routes').then(m => m.routes),
  },
  {
    path: 'user-rehire-card',
    loadChildren: () =>
      import('./user-rehire-card/user-rehire-card-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'user-search-card',
    loadChildren: () =>
      import('./user-search-card/user-search-card-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'username',
    loadChildren: () =>
      import('./username/username-stories.routes').then(m => m.routes),
  },
  {
    path: 'video-record-input',
    loadChildren: () =>
      import('./video-record-input/video-record-input-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'video-record-modal',
    loadChildren: () =>
      import('./video-record-modal/video-record-modal-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'worked-time',
    loadChildren: () =>
      import('./worked-time/worked-time-stories.routes').then(m => m.routes),
  },
];
